import { Button } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './styles.css';

export const ChangeAnswerMobile: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <div className={styles['change-answer']}>
      <Button fullWidth theme="fill_secondary" onClick={onClick}>
        Изменить ответ
      </Button>
    </div>
  );
};
